export default "__VITE_ASSET__CmEaZNdb__"